import { Language } from '../../lang/Language'

export class CannotStackPotsBeforeShowdown extends Error {
  constructor() {
    super(Language.strings.error.table.cannotStackPotsBeforeShowdown)
  }
}
